import { ReactNode } from 'react';
import { Store } from '../../core/createStore';
import UserRepository from '../../service/userRepository';
import { Modal } from "antd";

class Invite {
  private userRepository: UserRepository;
  private store: Store;

  constructor ({ userRepository, store }: {
    userRepository: UserRepository;
    store: Store;
  }) {
    this.userRepository = userRepository;
    this.store = store;
  }

  public async invite(email: string): Promise<void> {
    const session = this.store.getState().currentSession;

    if (!session) {
      throw new Error('It is cannot have reach here.');
    }

    try {
      const result = await this.userRepository.invite(session, { email });

      if (!result.result) {
        throw new Error('Failed invite.');
      }
    } catch (err) {
      this.showError({ messages: ['メール送信に失敗しました'], err });
      throw err;
    }
  }

  private showError ({
                       title = 'Error',
                       messages,
                       err,
                     }: {
    title?: string,
    messages: ReactNode[],
    err: any,
  }): void {
    if (!err || !err.response) {
      Modal.error({
        title: title,
        content: messages,
      });
      return;
    }
    switch (err.response.status) {
      case 401:
      case 404: {
        Modal.error({
          title: title,
          content: messages,
        });
        break;
      }
      case 403:
      case 503: {
        Modal.error({
          title: 'アクセスが制限されています',
          content: '管理者にお問い合わせください',
        });
        break;
      }
      default: {
        Modal.error({
          title: title,
          content: messages,
        });
        window.console.error(err);
      }
    }
  }
}

export default Invite;
